var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn"},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.backButton}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }